<!-- eslint-disable vue/multi-word-component-names -- Existing component, kept for backward compatibility -->
<template>
    <div :class="isNadiaChatRefreshEnabled ? 'disclaimer-refresh' : 'disclaimer'">
        <p :class="isNadiaChatRefreshEnabled ? 'disclaimer-refresh-text' : 'disclaimer-text'">
            <MarkdownText v-if="replaceFullMessage && hasAdditionalMessage" :text="additionalMessage" inline :linkify="false" />
            <template v-else>
                Messages in this chat are AI-generated.
                <template v-if="hasAdditionalMessage && !noModal">
                    <br class="sm:hidden" />
                    Remember to adhere to <BaseButton type="button" theme="tertiary" size="sm" @click="openDialog()">company guidelines</BaseButton>.
                </template>
            </template>
        </p>
        <MarkdownText
            v-if="hasAdditionalMessage && noModal && !replaceFullMessage"
            :class="isNadiaChatRefreshEnabled ? 'disclaimer-refresh-text' : 'disclaimer-text'"
            :text="additionalMessage" />
    </div>
    <BaseDialog v-model:open="isDialogOpen" title="Company Disclaimer" width="narrow">
        <MarkdownText class="body-small md:body-semibold" :text="additionalMessage" />
    </BaseDialog>
</template>

<script setup lang="ts">
import BaseButton from "~vue/components/BaseButton.vue";
import BaseDialog from "~vue/components/BaseDialog.vue";
import { useNadiaChatRefreshEnabled } from "~vue/composables/useNadiaChatRefresh";
import MarkdownText from "~vue/MarkdownText.vue";
import { computed, ref } from "vue";

const isNadiaChatRefreshEnabled = useNadiaChatRefreshEnabled();
const { message = "" } = defineProps<{ message?: string }>();
const additionalMessage = computed(() => (message ?? "").replaceAll("/no-modal/", "").replaceAll("/replace-full-message/", "").trim());
const hasAdditionalMessage = computed(() => !!additionalMessage.value);
const noModal = computed(() => message?.includes("/no-modal/"));
const replaceFullMessage = computed(() => message?.includes("/replace-full-message/"));

const isDialogOpen = ref(false);
const openDialog = () => (isDialogOpen.value = true);
</script>

<style scoped>
@reference "../../css/tailwind.css";

@layer components {
    .disclaimer {
        @apply text-center px-4 lg:px-6 lg:py-2 lg:border-2 lg:border-border lg:bg-surface lg:rounded-xl;

        &:where(html[data-theme="tonal"] *) {
            @apply bg-transparent border-0;
        }
    }

    .disclaimer-text {
        @apply details lg:body-small text-ink-muted;

        &:where(html[data-theme="tonal"] *) {
            @apply scaffold-details-small lg:scaffold-body-small;
        }
    }

    .disclaimer-refresh {
        @apply text-center;
    }

    .disclaimer-refresh-text {
        @apply scaffold-details-small text-ink-muted;
    }
}
</style>
